import { IconExclamationTriangle } from '@sequencehq/core-components'
import { SimplePaymentPage } from 'modules/PaymentsApp/components/SimplePaymentPage'

export const Error = () => {
  return (
    <SimplePaymentPage
      icon={IconExclamationTriangle}
      iconColour="red.60"
      header="Payment error"
      subheader="An unexpected error occurred while initiating the payment process."
      nextSteps={[
        'If you wish to proceed with the payment please try again or contact the issuer for further assistance.'
      ]}
    />
  )
}
